import { z } from "zod";
import { fileSchema } from "../files";

export const documentFormSchema = z
  .object({
    documentType: z.enum(["file", "link"]),
    name: z.string().min(1, "Le nom du document est requis"),
    link: z.union([z.string().url(), z.literal("")]).optional(),
    pdfFile: fileSchema.nullable(),
    thumbnail: fileSchema,
  })
  .refine(
    (data) => {
      if (data.documentType === "file") {
        return data.pdfFile !== null;
      }
      return true;
    },
    {
      message: "Un fichier PDF est requis",
      path: ["pdfFile"],
    },
  )
  .refine(
    (data) => {
      if (data.documentType === "link") {
        return data.link && data.link.trim().length > 0;
      }
      return true;
    },
    {
      message: "Un lien est requis",
      path: ["link"],
    },
  )
  .refine((data) => data.thumbnail !== null, {
    message: "Une miniature est requise",
    path: ["thumbnail"],
  });

export type DocumentFormValues = z.infer<typeof documentFormSchema>;

export const documentFormDefaultValues = {
  documentType: "file",
  name: "",
  link: "",
  pdfFile: null,
  thumbnail: null,
} as unknown as DocumentFormValues;
